/**
 * Reorders `items` so their keys match `newOrderKeys`; use when items are identified by a derived
 * key rather than a string `id`. Unknown keys are skipped and items not listed are dropped.
 */
export function reorderByKey<T>(
  items: readonly T[],
  newOrderKeys: readonly string[],
  keyOf: (item: T) => string,
): T[] {
  const byKey = new Map(items.map((item) => [keyOf(item), item]));
  return newOrderKeys.map((key) => byKey.get(key)).filter((item): item is T => item !== undefined);
}

/**
 * Reorders `items` so the resulting ids match `newOrderIds` exactly.
 * Items whose ids are not in `newOrderIds` are dropped; ids in
 * `newOrderIds` that don't match any item are skipped.
 */
export function reorderById<T extends { readonly id: string }>(
  items: readonly T[],
  newOrderIds: readonly string[],
): T[] {
  return reorderByKey(items, newOrderIds, (item) => item.id);
}
